import React, { useRef, useEffect, useState } from "react";
import Basemap from "@arcgis/core/Basemap";
import ImageryLayer from "@arcgis/core/layers/ImageryLayer";
import Map from "@arcgis/core/Map";
import MapImageLayer from "@arcgis/core/layers/MapImageLayer";
import VectorTileLayer from "@arcgis/core/layers/VectorTileLayer";
import TileLayer from "@arcgis/core/layers/TileLayer";
import { connect } from "react-redux";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import { appConifg } from "../../config/default";
import ArcGISMap from "@arcgis/core/Map";
//import esriConifg from '@arcgis/core/config'
import WebMap from "@arcgis/core/WebMap";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import Graphic from "@arcgis/core/Graphic";
import Locator from "@arcgis/core/tasks/Locator";
import QueryTask from "@arcgis/core/tasks/QueryTask";
import Query from "@arcgis/core/tasks/support/Query";
import GeometryService from "@arcgis/core/tasks/GeometryService";
import Geometry from "@arcgis/core/geometry";
import * as esriGeometryJsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import * as esriCoreUrlUtils from "@arcgis/core/core/urlUtils";
import Point from "@arcgis/core/geometry/Point";
import TextSymbol from "@arcgis/core/symbols/TextSymbol";
import Polygon from "@arcgis/core/geometry/Polygon";
import Extent from "@arcgis/core/geometry/Extent";
import SpatialReference from "@arcgis/core/geometry/SpatialReference";
import * as esriProject from "@arcgis/core/geometry/projection";
//import { load, project as esriProject } from '@arcgis/core/geometry/projection'
import MapView from "@arcgis/core/views/MapView";
import BaseMapGallery from "@arcgis/core/widgets/BasemapGallery";
import LayerList from "@arcgis/core/widgets/LayerList";
import ScaleBar from "@arcgis/core/widgets/ScaleBar";
import Home from "@arcgis/core/widgets/Home";
import Expand from "@arcgis/core/widgets/Expand";
import Attribution from "@arcgis/core/widgets/Attribution";
import esriConfig from "@arcgis/core/config.js";
import axios from "axios";
import MapSearchbar from "../MapSearch/MapSearchbar";
import DrawerIcons from "./drawerIcons";

import { searchAddressByParcelId } from "../MapSearch/MapSearchbar";
import MapActions from "./mapActions";
// to identify conflict
import {
  generatePortalToken,
  getParcelDetails,
  getStreetDetails,
  getAddressDetials,
  getPostalAreaDetails,
  getAreaDetails,
  getLabelPointOfPolygon,
  getAddressDetailsFromParcelId,
} from "../../serviceClients/addressingClient";
import {
  addressDetailsMapper,
  addressingApiResponseMapper,
} from "../mappers/addressingMappers";
import {
  const_address_point_symbol,
  const_issue_incorrect_address_point,
  const_missing_address_point,
  const_damage_sinage_point,
  const_missing_sinage_point,
  const_isssue_address_point,
  const_address_parcel_graphic_symbol,
  const_address_area_symbol,
  const_address_line_street_symbol,
  const_not_found_point_symbol,
  const_txt_symobl_for_graphics,
  const_mapPnt,
  const_wrong_Pin,
} from "./addressConfigUtils";
//Other Utilty Methods and Variables

//Actions import
import {
  fetchAddressDetailsRequest,
  fetchAdressDetailsSuccess,
  fetchAddressDetailsFailure,
  clearAddressDetails,
} from "../../redux/reducers/addressDetailsReducer";

import {
  fetchAddressResultSuccess,
  fetchAddressResultFailure,
  fetchAddressResultRequest,
  clearAddressResult,
} from "../../redux/actions/addressingResultActions";
import { setSidePanelStatusAndResultType } from "../../redux/actions/mapPanelControlActions";

import { useDispatch } from "react-redux";
import TranspController from "./TranspController";
import MapSwitcher from "./MapSwitcher";
//import AddressSearchBar from "../AddressSearch/AddressSearchBar";

/* 
  Reading from App Configuration */
const _PROXY_URL = appConifg.ProxyUrl;
const _AERIAL_IMAGERY = appConifg.Map.AerialImagery;
const _TOKEN_URL = appConifg.Map.TokenUrl;
const _PORTAL_USER_NAME = appConifg.Map.PortalUserName;
const _PORTAL_PASSWORD = appConifg.Map.PortalPassword;
const _APP_REFERER = appConifg.Map.AppReferer;
const _LOCATOR_SERVICE_URL = appConifg.Address.LocatorServiceUrl;
const _PARCEL_SERVICE_URL = appConifg.Address.ParcelServiceUrl;
const _POINT_ADDRESS_SERVICE_URL = appConifg.Address.PointAddressServiceUrl;
const _GEOMETRY_SERVICE_URL = appConifg.Address.GeometryServiceUrl;
const _RAK_STREETS_TILE_En =
  "https://rakgisstg.rak.ae/server/rest/services/Addressing/AddressMapImageHollowV2/MapServer";
const _RAK_STREETS_TILE_Ar =
  "https://rakgisstg.rak.ae/server/rest/services/Addressing/AddressMapImageHollowV2/MapServer";

//esri Configuration ---
esriConfig.assetsPath = "./assets";

// //esriConfig.request.proxyUrl = _PROXY_URL   //not working
// //esriConfig.request.proxyRules = proxy_rules //not working but working with urlUtils
const proxy_rules = [
  {
    urlPrefix: _AERIAL_IMAGERY,
    proxyUrl: _PROXY_URL,
  },
  {
    urlPrefix: _LOCATOR_SERVICE_URL,
    proxyUrl: _PROXY_URL,
  },
  {
    urlPrefix: _POINT_ADDRESS_SERVICE_URL,
    proxyUrl: _PROXY_URL,
  },
  {
    urlPrefix: _GEOMETRY_SERVICE_URL,
    proxyUrl: _PROXY_URL,
  },
];
//Add Proxy_rules to esriConfig
//proxy_rules.forEach(item=> {esriCoreUrlUtils.addProxyRule(item)})
esriCoreUrlUtils.addProxyRule(proxy_rules[0]);
esriCoreUrlUtils.addProxyRule(proxy_rules[1]);
esriCoreUrlUtils.addProxyRule(proxy_rules[2]);
esriCoreUrlUtils.addProxyRule(proxy_rules[3]);
esriCoreUrlUtils.addProxyRule({
  urlPrefix: _RAK_STREETS_TILE_En,
  proxyUrl: _PROXY_URL,
});

esriCoreUrlUtils.addProxyRule({
  urlPrefix: _RAK_STREETS_TILE_Ar,
  proxyUrl: _PROXY_URL,
});

let view = null;

/* For Adding Layers Individually */
/*1 Constrction BaseMap with Aeiral Imagery */
const ae2019ImgLyr = new ImageryLayer({
  url: _AERIAL_IMAGERY,
});

const ae2019BaseMap = new Basemap({
  baseLayers: [ae2019ImgLyr],
  title: "Aerial Imagery 2019",
  id: "ae2019",
});

let initialExtent = new Extent({
  ymax: 2990773.05734144,
  xmin: 6128491.02770031,
  xmax: 6370106.22272346,
  ymin: 2867470.43283262,
  spatialReference: new SpatialReference({ wkid: 102100 }),
});

const map = new Map({
  basemap: ae2019BaseMap,
  //basemap: "satellite", //satellite streets
});

const homeWidget = new Home({});
const basemapGallery = new BaseMapGallery({});
const scaleBar = new ScaleBar({ style: "line", unit: "dual" });
const layerList = new LayerList({});
const layerListExpand = new Expand({
  expandIconClass: "esri-icon-layer-list",
  content: layerList,
});

//Construction A Graphic Layer
const mapGraphicLayer = new GraphicsLayer({
  id: "gl_addressing_01",
  title: "Address_gl",
  listMode: "hide",
});

// const rak_streetsLyrEn = new VectorTileLayer({
//   url: _RAK_STREETS_TILE_En,
//   id: "rak_streets_tile_en",
//   visible: true,
// });

// const rak_streetsLyrAr = new VectorTileLayer({
//   url: _RAK_STREETS_TILE_Ar,
//   id: "rak_streets_tile_ar",
//   visible: true,
// });

//Try Base Map-----Map Service
const rak_streetsLyrEn = new MapImageLayer({
  url: _RAK_STREETS_TILE_En,
  id: "rak_streets_tile_en",
  visible: true,
});

const rak_streetsLyrAr = new MapImageLayer({
  url: _RAK_STREETS_TILE_Ar,
  id: "rak_streets_tile_ar",
  visible: true,
});

//create locator
// Find address
const locatorTask = new Locator({
  url: _LOCATOR_SERVICE_URL,
});

const geometryServiceTask = new GeometryService({ url: _GEOMETRY_SERVICE_URL });

const queryTask = new QueryTask();
// }

function AddressingMapViewOption3(props) {
  const dispatch = useDispatch(); //To Dipatch
  const mapDiv = useRef(null); //Reference for MapDiv DOM Element

  //Getting Varialbes from Store
  const store_address_result = props.addressingResult;
  var store_appToken =
    props.appSettings &&
    props.appSettings.userCredentials &&
    props.appSettings.userCredentials.token
      ? props.appSettings.userCredentials.token.access_token
      : null;
  const isLangArActive = props.appSettings.language === "ar";

  //Local State
  const [
    isReverseGeoCodingInProgress,
    SetIsReverseGeoCodingInProgress,
  ] = useState(false);
  //Hook to initiate the Map and add layers
  useEffect(() => {
    let mounted = true;

    if (mapDiv.current) {
      //getAddressPointDetails("11141")
      //Adding Map to DOM
      view = new MapView({
        map: map,
        container: mapDiv.current,
        extent: initialExtent,
        constraints: {
          snapToZoom: false,
          rotationEnabled: false,
        },
      });

      homeWidget.view = view;
      basemapGallery.view = view;
      scaleBar.view = view;
      layerList.view = view;
      layerListExpand.view = view;
      // view.ui.add(basemapGallery,"bottom-right")
      view.ui.add(homeWidget, "top-left");
      view.ui.add(scaleBar, "bottom-left");
      // view.ui.add(layerList,"top-left")
      // view.ui.add(layerListExpand, "top-right");
      // view.ui.remove("attribution");
      view.popup.autoOpenEnabled = false;
      // view.popup.autoCloseEnabled = false

      //  view.map.addMany([mapGraphicLayer])
      view.map.add(mapGraphicLayer, 1); //Adding at index 1
      // if(isLangArActive)
      // //view.map.addMany([  rak_streetsLyrEn ,  mapGraphicLayer]);
      // // view.map.addMany([mapGraphicLayer])
      // else
      // //view.map.addMany([  rak_streetsLyrAr ,  mapGraphicLayer]);

      //Handle Reverse GeoCode on MapClick
      view.on("click", function (event) {
        console.log("Map Click ", event.mapPoint);
        if (mounted) {
          clearAddressGraphicsLayer();
          //reverseGeoCode(event.mapPoint);
          dispatch(
            fetchAddressResultRequest("Map_Click", event.mapPoint.toJSON())
          );

          //Get 4326 coordinates before reverse geocod and send it to reverse geocode to store it in store
          let outSpatialReference = new SpatialReference({ wkid: 4326 });
          esriProject.load().then(() => {
            let projectPnt4326 = esriProject.project(
              event.mapPoint,
              outSpatialReference
            );

            reverseGeoCode2(event.mapPoint, projectPnt4326);
          });
        }
      });
      view.when(() => {
        view.zoom = 9;
      });
    }
    return () => {
      //eg: remove handlers etc.here cleanUp code
      mounted = false;
    };
  }, []);

  //hook to handle Language Change --and change base Vector tile
  useEffect(() => {
    if (!props.appSettings.language) return;
    if (!view || !view.map.layers || view.map.layers.length < 0) return;
    var rk_streets = view.map.allLayers.find(
      (lyr) =>
        lyr.id === "rak_streets_tile_en" || lyr.id === "rak_streets_tile_ar"
    );
    if (rk_streets) {
      view.map.remove(rk_streets);
    }
    if (props.appSettings.language === "ar") {
      view.map.add(rak_streetsLyrAr, 0);
    } else if (props.appSettings.language === "en") {
      view.map.add(rak_streetsLyrEn, 0);
    }
  }, [props.appSettings.language]);

  // useEffect(()=>{
  //   store_appToken = (props.appSettings && props.appSettings.userCredentials && props.appSettings.userCredentials.token) ?  props.appSettings.userCredentials.token.access_token : null
  // },[props.appSettings.userCredentials])

  //Hook to Handle Change in AddressResult
  useEffect(() => {
    let mounted = true;
    if (
      store_address_result.candidates &&
      store_address_result.candidates.length < 1
    ) {
      console.log("No Address Result Found");
      //clear old results
      clearAddressGraphicsLayer();
      return;
    } else if (
      store_address_result.candidates[0].isParcelSearch ||
      store_address_result.candidates[0].isReverseGeocode
    ) {
      clearAddressGraphicsLayer();
      //is parcel search so no need to get details again all the details are avaliable so just dspatch
      if (mounted)
        props.fetchedAddressDetailsSuccessfully(
          store_address_result.candidates[0]
        );
    } else {
      clearAddressGraphicsLayer();
      let address_candiate = store_address_result.candidates[0];
      if (mounted) displayAddressGraphic(address_candiate);
    }

    return () => {
      mounted = false;
    };
  }, [store_address_result]);

  //hook to handle Change in AddressDetails -- PointGraphic and draw it on Map --- Not Used For Now
  useEffect(() => {
    let mounted = true;

    var address_data = props.addressDetails.data; //from store
    if (!address_data || address_data.length < 1) return;
    if (props.addressDetails.loading) return;

    let lat = address_data.latitude;
    let lng = address_data.longitude;
    let positionX = address_data.positionX;
    let positionY = address_data.positionY;
    if (mounted) {
      // clearAddressGraphicsLayer() //clear old one before adding now
      displayPointAddressGraphic2(
        { x: positionX, y: positionY },
        address_data.parcelGeometry
      );
    }

    return () => {
      mounted = false;
    };
  }, [props.addressDetails.data]);

  const reverseGeoCode2 = (mapPoint, clickPoint4326) => {
    // if(!props.isAddressPanelOpen) props.openAddressPanel()
    triggerAddressPanelOpen();
    clearMapSearchText(); //Bad way of clearing MapSearchBar text --TODO change to store based model (react way)
    SetIsReverseGeoCodingInProgress(true);
    const params = { location: mapPoint };
    dispatch(props.clearAddressDetails());
    //dispatch(fetchAddressResultRequest("Map_Click", mapPoint.toJSON()));
    dispatch(fetchAddressResultRequest("Map_Click", clickPoint4326.toJSON())); //Again Dispatching to change map point to 4326
    locatorTask
      .locationToAddress(params)
      .then((resp) => {
        const parcel_address = resp.address; //here we will ge the parcel id
        // dispatch(fetchAddressResultSuccess([resp]));
        getAndDisplayAddressDetailsFromParcelId(parcel_address, mapPoint);
      })
      .catch((err) => {
        const errMsg = err.message;
        if (errMsg == "Cannot perform query. Invalid query parameters.") {
          //means no matching address found
          dispatch(fetchAddressResultSuccess([]));
          noResultFromReverseGeoCodeAction(mapPoint);
        } else {
          dispatch(fetchAddressResultFailure(errMsg));
        }
      })
      .then(() => {
        SetIsReverseGeoCodingInProgress(false);
      });
  };

  const getAndDisplayAddressDetailsFromParcelId = (
    parcel_address,
    mapPoint
  ) => {
    const [promise, source] = getAddressDetailsFromParcelId(
      parcel_address,
      props.appSettings.userCredentials.token.access_token
    ); // store_appToken
    promise
      .then((resp) => {
        console.log(resp.data);
        const {
          isSuccess,
          isPartial,
          message,
          respData,
          successObj,
          failedObj,
        } = addressingApiResponseMapper(resp.data);
        if (isSuccess) {
          var addressData = addressDetailsMapper(respData);
          var dipatchData = { ...addressData, isReverseGeocode: true };
          // props.fetchedAddressDetailsSuccessfully([dipatchData]);
          dispatch(fetchAddressResultSuccess([dipatchData]));
        } else {
          // props.faiedTofetchAddressDetails(message);
          dispatch(fetchAddressResultSuccess([]));
          noResultFromReverseGeoCodeAction(mapPoint);
        }
      })
      .catch((err) => {
        //setSuggestionsState({isLoading:false, options :[] , query : search_text ,disbled : false })
        console.log("Coudnt Fetch Address Detail From Parcel ID ", err.message);
        const errMsg = err.message;
        //props.faiedTofetchAddressDetails(err.message);
        dispatch(fetchAddressResultFailure(errMsg));
      });
  };

  const reverseGeoCode = (mapPoint) => {
    //this method is not used anymore as the logic is changed to reveresGeoCode agains Parcels Locator
    //if(!props.isAddressPanelOpen) props.openAddressPanel()
    triggerAddressPanelOpen();
    if (isReverseGeoCodingInProgress) {
      // alert("In Progress wait");
      return;
    } else {
      SetIsReverseGeoCodingInProgress(true);
    }
    const params = {
      location: mapPoint,
      //,locationType :"Point Address"
    };
    dispatch(props.clearAddressDetails());
    //dispatch(props.clearAddressResult())
    dispatch(fetchAddressResultRequest("Map_Click", mapPoint.toJSON()));

    locatorTask
      .locationToAddress(params)
      .then((resp) => {
        console.log(JSON.stringify(resp));
        const r_address = resp.address;
        const r_address_attributes = resp.attributes;
        const address_type = r_address_attributes.Addr_type;
        console.log("Found Address of Type ", address_type);
        if (address_type === "PointAddress") {
          //only show point address in reverse GeoCode
          dispatch(fetchAddressResultSuccess([resp]));
        } else {
          dispatch(fetchAddressResultSuccess([])); //dispatching empty --as NonPoint Address is found  is reterieved
          noResultFromReverseGeoCodeAction(mapPoint);
        }

        SetIsReverseGeoCodingInProgress(false);
      })
      .catch((err) => {
        console.log(err.message);
        const errMsg = err.message;
        if (errMsg == "Cannot perform query. Invalid query parameters.") {
          //means no matching address found
          dispatch(fetchAddressResultSuccess([]));
          noResultFromReverseGeoCodeAction(mapPoint);
        } else {
          dispatch(fetchAddressResultFailure(errMsg));
        }
        SetIsReverseGeoCodingInProgress(false);
      });
  };

  const noResultFromReverseGeoCodeAction = (mapPoint) => {
    //Draw the map point graphic and may be show a popup no result found at the current location report issue
    const addressNotFound = new Graphic({
      geometry: mapPoint,
      symbol: const_not_found_point_symbol,
      // symbol : const_mapPnt
    });
    addGraphicToAddressGraphicLayer(addressNotFound);
  };

  const getAndDrawAddressPointDetails = (address) => {
    //Make Sure to Clear old Graphic
    //clearAddressGraphicsLayer()
    var street_number = address.attributes.StreetId.toString();
    var point_id = address.attributes.AddressPointId.toString();
    var area_id = address.attributes.AreaId.toString();

    props.initiatingAddressDetailsFetch(props.addressingResult.fetchType); //passing fetchType from AddrssResult store

    let [promise, source] = getAddressDetials(
      point_id,
      street_number,
      area_id,
      store_appToken
    );
    promise
      .then((resp) => {
        const {
          isSuccess,
          isPartial,
          message,
          respData,
          successObj,
          failedObj,
        } = addressingApiResponseMapper(resp.data);

        if (isSuccess) {
          props.fetchedAddressDetailsSuccessfully(
            addressDetailsMapper(respData)
          );
          //TODO - drwas Point address and Parcel outline on map -- may be using useEffect hook
        } else props.faiedTofetchAddressDetails(message);
      })
      .catch((err) => {
        console.log("Failed to get the AddressPoint Details ", err.message);
        props.faiedTofetchAddressDetails(err.message);
      });
  };

  const displayAddressGraphic = (address) => {
    var address_type = address.attributes.Addr_type;
    switch (address_type) {
      case "PointAddress":
        // drawAddressPointGraphic(address)
        console.log("Point Address ");
        //displayPointAddressGraphic(address) //This is wroking , but commented for now to get details from AddressServiceAPI
        //Since AddressPoint is found - Get the Address Point details for the AddressAPI service and
        getAndDrawAddressPointDetails(address);
        break;
      case "StreetName":
        props.clearAddressDetails();
        displayStreetAddressGraphic(address);
        break;
      case "Locality":
        props.clearAddressDetails();
        displayAreaGraphic(address);
        break;
      case "Postal":
        props.clearAddressDetails();
        displayPostalAreaGraphic(address);
        break;
      default:
        break;
    }
  };

  const [mapSearchValueDummy, setMapSearchValueDummy] = useState(1);
  const clearMapSearchText = () => {
    setMapSearchValueDummy((value) => ++value);
  };

  const triggerAddressPanelOpen = () => {
    //TODO check the logic here--trigger only if the panel is closed
    //if(!(props.mapPanelSetting.isSidePanelOpen && props.mapPanelSetting.resultType === "address")){
    props.openAddressPanel();
    // }
  };
  return (
    <>
      {/* <AddressSearchBar/> */}
      {/* <TranspController/> */}
      {/* <MapActions/> */}
      <MapSwitcher />
      <MapSearchbar mapSearchValueDummy={mapSearchValueDummy} />
      <DrawerIcons />
      <div className="mapDiv" ref={mapDiv}></div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    addressingResult: state.addressingResult,
    addressDetails: state.addressDetails,
    //isAddressPanelOpen : (state.mapPanelSetting.isSidePanelOpen && state.mapPanelSetting.resultType === "address"),
    mapPanelSetting: state.mapPanelSetting,
    appSettings: state.settings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    initiatingAddressDetailsFetch: (fetch_type) => {
      return dispatch(fetchAddressDetailsRequest(fetch_type));
    },
    fetchedAddressDetailsSuccessfully: (data) => {
      return dispatch(fetchAdressDetailsSuccess(data));
    },
    faiedTofetchAddressDetails: (error) => {
      return dispatch(fetchAddressDetailsFailure(error));
    },
    clearAddressDetails: () => {
      return dispatch(clearAddressDetails());
    },
    openAddressPanel: () => {
      return dispatch(setSidePanelStatusAndResultType("true", "address")); //to display the sidePanel
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddressingMapViewOption3);

const displayPointAddressGraphic2 = (address_location, parcel_geometry) => {
  //here get the 32640 to avoid Projecting to 4326

  if (parcel_geometry) {
    //Parcel Geometry now
    var geometry_poly_rings = parcel_geometry.rings;
    var pracel_polygon_json = {
      type: "polygon",
      rings: geometry_poly_rings,
      spatialReference: { wkid: 32640 },
    };
    var parcel_graphic = new Graphic({
      geometry: pracel_polygon_json,
      symbol: const_address_parcel_graphic_symbol,
      id: "address_graphic",
    });
    clearAddressGraphicsLayer(); //Clear the old one before adding now
    /* To Hide parcel boundary (as required for zoom made symbol transparent) -- 2nd August 2021  */
    addGraphicToAddressGraphicLayer(parcel_graphic);
    zoomToSingleGraphic(parcel_graphic);
  }

  //Plot the point on map

  const address_point_32640 = new Point({
    x: address_location.x,
    y: address_location.y,
    spatialReference: { wkid: 32640 },
  });

  const addressGraphic = new Graphic({
    geometry: address_point_32640,
    symbol: const_address_point_symbol,
  });
  addGraphicToAddressGraphicLayer(addressGraphic);

  //Not required any more below conversion as we have the xy from the webservice response
  return;
  const address_point_4326 = new Point({
    //Create a point in 4326
    x: address_location.x,
    y: address_location.y,
    spatialReference: { wkid: 4326 },
  });

  let outSpatialReference = new SpatialReference({ wkid: 32640 });
  esriProject.load().then(() => {
    let projectPnts = esriProject.project(
      [address_point_4326],
      outSpatialReference
    );
    projectPnts.forEach((pnt) => {
      console.log("After Prj ", pnt.x, pnt.y);
      const addressGraphic = new Graphic({
        geometry: projectPnts[0],
        symbol: const_address_point_symbol,
      });
      addGraphicToAddressGraphicLayer(addressGraphic);
    });
  });
};

//not used to remove
// const MapXYToLatLng = (x, y)=>{
//   const point32640 = new Point({
//     x: x,
//     y :y,
//     spatialReference :{ wkid : 32640}
//   })
//   let outSpatialReference = new SpatialReference({ wkid: 4326 });
//   esriProject.load().then(()=>{
//     let projectPnts = esriProject.project([point32640],outSpatialReference);
//   })
// }

const displayStreetAddressGraphic = (address) => {
  var street_number = address.attributes.StreetId;
  const [promise, source] = getStreetDetails(street_number);
  promise
    .then((resp) => {
      console.log("Street Details " + resp.data);
      var respData = resp.data;
      if (respData.features && respData.features.length > 0) {
        var f_paths = respData.features[0].geometry.paths;
        var pfeatures = {
          type: "polyline",
          paths: f_paths,
          spatialReference: { wkid: 32640 },
        };
        var pGraphic = new Graphic({
          geometry: pfeatures,
          symbol: const_address_line_street_symbol,
        });
        addGraphicToAddressGraphicLayer(pGraphic);
        zoomToAreaGraphic(pGraphic);
      } else {
        console.log("No Street Features Returned ");
      }
    })
    .catch((err) => {
      console.log("Error while gettig street ", err.message);
    });
};

const displayAreaGraphic = (address) => {
  var areaId = address.attributes.AreaId;
  const [promise, source] = getAreaDetails(areaId);
  promise
    .then((resp) => {
      var respData = resp.data;
      if (respData.features && respData.features.length > 0) {
        var fAttributes = respData.features[0].attributes;
        var g_rings = respData.features[0].geometry.rings;
        var pfeature = {
          type: "polygon",
          rings: g_rings,
          spatialReference: { wkid: 32640 },
        };
        var pGraphic = new Graphic({
          geometry: pfeature,
          symbol: const_address_area_symbol,
        });
        addGraphicToAddressGraphicLayer(pGraphic);
        zoomToAreaGraphic(pGraphic);

        //For Label Area
        geometryServiceTask
          .labelPoints([new Polygon(pfeature)])
          .then((labelPoint) => {
            var txtSymbol = new TextSymbol(const_txt_symobl_for_graphics);
            txtSymbol.text = fAttributes.NameEn;
            var labelPointGraphic = new Graphic(labelPoint[0], txtSymbol);
            mapGraphicLayer.graphics.add(labelPointGraphic);
          })
          .catch((err) => {
            console.log(err.message);
          });

        //Use Geometry Service - label Point to find the label point
        // const [promise2, source2] = getLabelPointOfPolygon(new Polygon(pfeature));
        // promise2
        //   .then((resp) => {
        //     var respData = resp.data;
        //     if (respData.labelPoints && respData.labelPoints.length > 0) {
        //       let lblPt = respData.labelPoints[0];
        //       var txtSymbol = new TextSymbol(const_txt_symobl_for_graphics);
        //       txtSymbol.text = "Sample Ext For now";
        //       var labelPointGraphic = new Graphic(
        //         new Point({
        //           x: lblPt.x,
        //           y: lblPt.y,
        //           spatialReference: { wkid: 32640 },
        //         }),
        //         txtSymbol
        //       );
        //       mapGraphicLayer.graphics.add(labelPointGraphic);
        //     }
        //   })
        //   .catch((err) => {
        //     console.log(err.message);
        //   });
      } else {
        console.log("No Area found");
      }
    })
    .catch((err) => {
      console.log("Error while getting  Area");
    });
};

const displayPostalAreaGraphic = (address) => {
  var emPostCode = address.attributes.Postal;
  var farea = address.attributes.City;
  const [promise, source] = getPostalAreaDetails(emPostCode);
  promise
    .then((resp) => {
      var respData = resp.data;
      if (respData.features && respData.features.length > 0) {
        var fAttributes = respData.features[0].attributes;
        var g_rings = respData.features[0].geometry.rings;
        var pfeature = {
          type: "polygon",
          rings: g_rings,
          spatialReference: { wkid: 32640 },
        };
        var pGraphic = new Graphic({
          geometry: pfeature,
          symbol: const_address_parcel_graphic_symbol,
        });
        addGraphicToAddressGraphicLayer(pGraphic);
        zoomToAreaGraphic(pGraphic);

        //for label Postal Area
        geometryServiceTask
          .labelPoints([new Polygon(pfeature)])
          .then((labelPoint) => {
            var txtSymbol = new TextSymbol(const_txt_symobl_for_graphics);
            txtSymbol.text = fAttributes.EmPostCode + "\n" + farea;
            var labelPointGraphic = new Graphic(labelPoint[0], txtSymbol);
            mapGraphicLayer.graphics.add(labelPointGraphic);
          })
          .catch((err) => {
            console.log(err.message);
          });
      } else {
        console.log("No Postal Area found");
      }
    })
    .catch((err) => {
      console.log("Error while getting Postal Area");
    });
};

const addGraphicToAddressGraphicLayer = (graphic) => {
  mapGraphicLayer.graphics.add(graphic);
};

const clearAddressGraphicsLayer = () => {
  mapGraphicLayer.removeAll();
};

const removeGraphicFromGraphicLayer = (graphicId) => {
  let toRemoveGraphic = mapGraphicLayer.graphics.find((g) => {
    return g.id == graphicId;
  });
  if (toRemoveGraphic) mapGraphicLayer.graphics.remove(toRemoveGraphic);
};

//zoom to Area and Postal area --setting the expand value to 4 for better zoom level
const zoomToAreaGraphic = (graphic) => {
  if (!view) return;
  if (!graphic) return;
  if (!view.map || !view.map.basemap || !view.map.basemap.spatialReference) {
    if (!view.spatialReference) return;
  }
  if (!view.spatialReference) return;
  //let viewWKID = view.spatialReference.wkid
  if (esriProject.isLoaded()) {
    let toZoomGeom = esriProject.project(
      graphic.geometry,
      view.spatialReference
    );
    toZoomGeom.extent.expand(4); //HardCoded Expand
    view.goTo(toZoomGeom, { duration: 2000 });
  } else {
    esriProject.load().then(() => {
      let toZoomGeom = esriProject.project(
        graphic.geometry,
        view.spatialReference
      );
      toZoomGeom.extent.expand(4); //HardCoded Expand
      view.goTo(toZoomGeom, { duration: 2000 });
    });
  }
  // var gGeom = graphic.geometry.clone();
  // gGeom.extent.expand(4); //Hardcoded expand factor
  // view.goTo(gGeom, { duration: 2000 });
  // return;
};

const zoomToSingleGraphic = (graphic) => {
  if (!view.map || !view.map.basemap || !view.map.basemap.spatialReference) {
    if (!view.spatialReference) return;
  }

  if (!view.spatialReference) return;
  if (!view) return;
  if (!graphic) return;
  let veiwWKID = view.spatialReference.wkid;

  if (graphic.geometry.spatialReference.wkid !== veiwWKID) {
    esriProject.load().then(() => {
      let toZoomGeom = esriProject.project(
        graphic.geometry,
        view.spatialReference
      );
      toZoomGeom.extent.expand(5); //HardCoded Expand
      view.goTo(toZoomGeom, { duration: 2000 });
    });
  }

  return;

  var gGeom = graphic.geometry.clone();
  gGeom.extent.expand(6); //Hardcoded expand factor
  view.goTo(gGeom, { duration: 2000 });
  return;
  view.goTo(graphic.geometry, { duration: 2000 }).then(() => {
    console.log("Zoom Done");
    var gGeom = graphic.geometry.clone();
    gGeom.extent.expand(6); //Hardcoded expand factor
    view.goTo(gGeom, { duration: 2000 });
  });
};

//not used
const getAddressPointDetails = (pointId) => {
  console.log("getAddressPoint Details ");

  let query = new Query();
  query.returnGeometry = true;
  query.outFields = ["*"];
  query.where = `AddressPointId='${pointId}'`;

  let queryTask = new QueryTask({
    url: _POINT_ADDRESS_SERVICE_URL,
  });
  queryTask
    .execute(query)
    .then((resp) => {
      console.log("Query Task result");
      console.log(resp.toJSON);
    })
    .catch((err) => {
      console.log(err);
    });
};

const getLabelPointForSinglePolygon = (polygon) => {};

//called by other components to zoom to the found address graphic
export const zoomToDisplayedAddressGraphic = () => {
  console.log(" Will zoom to Address Graphic ");
  var address_g = mapGraphicLayer.graphics.getItemAt(0);
  if (address_g) zoomToSingleGraphic(address_g);
};

export const DisplayAddressIssuePointOnMap = (lat, lng) => {
  var p4326 = new Point({ longitude: lng, latitude: lat });
  let veiwWKID = view.spatialReference.wkid;
  esriProject.load().then(() => {
    let pView = esriProject.project(
      p4326,
      new SpatialReference({ wkid: veiwWKID })
    );

    view.zoom = 12;
    view.goTo(pView);
    removeGraphicFromGraphicLayer("ADDRESS_ISSUE_GRAPHIC");
    //Remove Previous graphic before adding
    const issueGraphic = new Graphic({
      id: "ADDRESS_ISSUE_GRAPHIC",
      geometry: pView,
      symbol: const_isssue_address_point,
    });
    addGraphicToAddressGraphicLayer(issueGraphic);
  });
};

export const ZoomToLatLng = (lat, lng) => {
  var p4326 = new Point({ longitude: lng, latitude: lat });
  let veiwWKID = view.spatialReference.wkid;
  esriProject.load().then(() => {
    let pView = esriProject.project(
      p4326,
      new SpatialReference({ wkid: veiwWKID })
    );

    //let pViewPoint = new Point({x:pView.x,y:pView.y, spatialReference : veiwWKID })
    //var gGeom = p32640.geometry
    //gGeom.extent.expand(6);
    view.zoom = 12;
    //view.center = [lat , lng]
    view.center = pView;
    // view.center = [pView.x, pView.y];
    //view.center = [p4326.x, p4326.y]
    //view.goTo(p32640)

    // view.goTo({
    //   center : [p32640.x , p32640.y],
    //   zoom : 12
    // })
  });
};

//remove the below method -- just to try transparency
export const setRakStreetsTransparency = (value) => {
  if (!view.map.layers || view.map.layers.length < 0) return;
  var rk_streets = view.map.allLayers.find((lyr) => lyr.id === "rak_streets");
  var opacity = (100 - value) / 100;
  rk_streets.opacity = opacity;

  var rk_streets_parcels = view.map.allLayers.find(
    (lyr) => lyr.id === "rak_streets_parcel"
  );

  rk_streets_parcels.opacity = opacity;
};

//use id to hide may it be En or Ar Vt
export const toggleRakStreetsTile = () => {
  var rk_streets = view.map.allLayers.find(
    (lyr) =>
      lyr.id === "rak_streets_tile_en" || lyr.id === "rak_streets_tile_ar"
  );
  if (rk_streets) {
    rk_streets.visible = !rk_streets.visible;
  }
};
